import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import get from 'lodash/get';
import each from 'lodash/each';
import join from 'lodash/join';
import uniqWith from 'lodash/uniqWith';
import isEqual from 'lodash/isEqual';
import findIndex from 'lodash/findIndex';
import indexOf from 'lodash/indexOf';
import User from 'yoda-site-components/lib/helpers/User/User';
import {
    isAddGiftCardLinkEligible,
    getOrderShippingType,
    getCurbsideEligible,
    isShipAloneAvailable,
    getDataForOOS,
} from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import {
    ANALYTICS_PAGE_NAME_CHECKOUT_SHIPPING,
    ANALYTICS_LOCAL_STORAGE_KEY_CART_TOTAL,
    ANALYTICS_PAGE_NAME_CHECKOUT_PAYMENT,
    ANALYTICS_PAGE_NAME_CHECKOUT_SAME_DAY_PICKUP,
    ANALYTICS_SUB_TOTAL,
    ADJUSTMENT_TYPE_REWARD,
    ADJUSTMENT_TYPE_ASSOC_DISCOUNT,
    ADJUSTMENT_TYPE_SHIPPING,
    ADJUSTMENT_TYPE_COUPON,
    ADJUSTMENT_TYPE_FREE_SHIP,
    DOLLAROFF,
    PERCENTOFF,
    CHARGE_TYPE_SHIPPING_AND_HANDLING,
    SHIPPING_GROUP_TYPE_BOPIS,
    SHIPPING_GROUP_TYPE_HOME,
    SHIPPING_GROUP_TYPE_STORE,
    shippingDeliveryType,
    ITEMS_TOTALS_NAME_TOTAL_WITHOUT_DISCOUNT,
    ORDER_TOTAL_NAME_SUBTOTAL,
    CHECKOUT_ACCORDION_TITLE_SDPU,
    CHECKOUT_ACCORDION_TITLE_SHIPPING,
    CHECKOUT_ACCORDION_TITLE_PAYMENT,
    BNPL_SYF,
} from 'yoda-checkout-components/lib/common/Constants';
import { getOrderGiftRegistries } from 'yoda-checkout-components/lib/actions/OrderGiftRegistriesAction';
import ExceptionHandler from 'yoda-checkout-components/lib/helpers/ExceptionHandler';
import * as checkoutAnalyticsActions from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import { setOosDetails } from 'yoda-checkout-components/lib/actions/OutOfStockActions';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { TRANSIENT_PAYMENT_ID } from './Utils/Utils';
import * as actions from '../actions/index';
import * as shippingActions from '../actions/ShippingAddressFormActions';
import * as checkoutActions from '../actions/CheckoutPageActions';
import { setAltCharges } from '../actions/AlternateChargeAction';
import { expressCheckoutDisplayed } from '../actions/ExpressCheckoutAction';
// eslint-disable-next-line import/no-cycle
import initBOPISSection from '../sagas/NewBOPISSaga';
// eslint-disable-next-line import/no-cycle
import initNewShippingSection from '../sagas/NewShippingSaga';
// eslint-disable-next-line import/no-cycle
import handleInitPaymentRequestSaga from '../sagas/NewPaymentSaga';
import { updateShippingMethodList } from '../actions/NewShippingAction';
import { initNewPayment } from '../actions/NewPaymentAction';
import PaymentService from '../services/PaymentService';

export default class OrderDetailsModel {
    constructor(orderDetailsResponse) {
        this.orderDetailsAPIResponse = orderDetailsResponse;
        const { data } = orderDetailsResponse;
        this.orderDetails = data;
        this.defaultAction = {
            type: 'FETCHING_DATA',
            payload: {},
        };
        if (!isEmpty(data)) {
            this.number = data.number;
            this.billing = data.billing;
            this.href = data.href;
            this.id = data.id;
            this.status = data.status;
            this.submittedDate = data.submittedDate;
            this.country = data.country;
            this.currency = data.currency;
            this.freeShippingThreshold = data.freeShippingThreshold;
            this.amountShortForShippingDiscount = data.amountShortForShippingDiscount;
            this.contact = data.contact;
            this.totals = data.totals;
            this.isPriceAccurate = data.isPriceAccurate;
            this.delivery = data.delivery;
            this.bag = data.bag;
            this.adjustments = data.adjustments;
            this.giftWraps = data.giftWraps;
            this.charges = data.charges;
            this.altCharges = data.altCharges;
            this.originalTotal = data.originalTotal;
            this.bnpl = data.bnpl;
            this.isJcpCardInOrder = PaymentService.isJcpCardInOrder(
                get(data, 'billing.creditCards.cards', [])
            );
            this.showAddGiftCardLink = isAddGiftCardLinkEligible(data);
        }
    }

    getOrderInfo = (nextPage, context, isPreLoadCall) => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        let financing = {};
        let options = get(this.orderDetails, 'billing.creditCards.financing.options');
        if (!options) {
            options = get(this.orderDetails, 'billing.creditCards.cards[0].financing.options');
        }
        const selectedOption = find(options, { selected: true });
        if (selectedOption) {
            financing = selectedOption;
        }
        const orderInfo = {
            orderId: this.number,
            href: this.href,
            id: this.id,
            number: this.number,
            status: this.status,
            submittedDate: this.submittedDate,
            country: this.country,
            currency: this.currency,
            financing,
            freeShippingThreshold: this.freeShippingThreshold,
            amountShortForShippingDiscount: this.amountShortForShippingDiscount,
            itemsCount: this.bag.itemCount,
            isPreLoadCall: !isEmpty(nextPage) || __SERVER__ || !!isPreLoadCall,
            isJcpCardInOrder: this.isJcpCardInOrder,
            showAddGiftCardLink: this.showAddGiftCardLink,
        };
        const orderShippingType = getOrderShippingType(this.delivery.groups || []);
        if (orderShippingType) {
            orderInfo.orderShippingType = orderShippingType;
        }
        /* istanbul ignore if */
        if (
            this.orderDetailsAPIResponse &&
            this.orderDetailsAPIResponse.headers &&
            this.orderDetailsAPIResponse.headers.get('X-ETag')
        ) {
            orderInfo.xEtagValue = this.orderDetailsAPIResponse.headers.get('X-ETag');
        }
        LocalStorage.setData('ItemCount', this.bag.itemCount, true);
        const enableCurbsideBanner = get(context, 'featureFlags.enableCurbsideBanner', true);
        if (enableCurbsideBanner) {
            orderInfo.showCurbsideBanner = getCurbsideEligible(this.bag.items, 'ocp');
        }
        const enableExposedPackagingMessage = get(
            context,
            'featureFlags.enableExposedPackagingMessage',
            true
        );
        orderInfo.shipAlone =
            enableExposedPackagingMessage && !!isShipAloneAvailable(this.bag.items);
        return actions.getOrderInfo(orderInfo);
    };

    getCreditCardInfo = () => {
        if (isEmpty(this.orderDetails) || isEmpty(this.billing)) {
            return this.defaultAction;
        }
        const { billing } = this;
        const contactInfo = this.contact && find(this.contact.methods, { type: 'EMAIL' });

        /* istanbul ignore else */
        if (
            !isEmpty(billing.creditCards) &&
            !isEmpty(billing.creditCards.cards) &&
            !isEmpty(billing.creditCards.cards[0])
        ) {
            const creditCardInfo = billing.creditCards.cards[0];
            const maskValue = {
                JCP: '******',
                AMEX: '***********',
                OTHERE: '************',
            };
            const creditCardNumber = `${
                maskValue[creditCardInfo.type] ? maskValue[creditCardInfo.type] : maskValue.OTHERE
            }${this.getCCLastFourDigit(creditCardInfo.type, creditCardInfo.lastFour)}`;
            const creditCardDetails = {
                cardType: creditCardInfo.type,
                creditCardNumber,
                creditCardYear: creditCardInfo.expiryYear,
                creditCardMonth: creditCardInfo.expiryMonth,
                billingAddress: creditCardInfo.address,
                email: contactInfo ? contactInfo.value : '',
            };
            creditCardDetails.billingAddress.state =
                creditCardDetails.billingAddress.state || creditCardDetails.billingAddress.province;
            const formatedCreditCardInfo = {
                creditCardInfo: creditCardDetails,
                currSelectId:
                    (creditCardInfo.relationships &&
                        creditCardInfo.relationships.accountPaymentMethod &&
                        creditCardInfo.relationships.accountPaymentMethod.id) ||
                    TRANSIENT_PAYMENT_ID,
            };
            return actions.getCreditCardInfo(formatedCreditCardInfo);
        }

        /* istanbul ignore next */
        if (!isEmpty(billing.paypal)) {
            const billingAddress =
                billing.paypal.address && billing.paypal.address.firstName
                    ? billing.paypal.address
                    : {};
            const formatedCreditCardInfo = {
                billingAddress,
                email: get(billing, 'paypal.email', get(contactInfo, 'value', '')),
            };
            return actions.getCreditCardInfo({ creditCardInfo: formatedCreditCardInfo });
        }

        /* istanbul ignore next */
        const firstName = get(billing, 'unnamed.address.firstName');
        // Aurora API not return address on GET order service call.
        if (firstName) {
            const formatedCreditCardInfo = {
                billingAddress: billing.unnamed.address,
                email: contactInfo ? contactInfo.value : '',
            };
            return actions.getCreditCardInfo({ creditCardInfo: formatedCreditCardInfo });
        }
        const orderContactInfo = contactInfo ? { email: contactInfo.value } : {};
        return actions.getCreditCardInfo({ creditCardInfo: orderContactInfo });
    };

    getContactInfo = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }

        const email = find(this.contact.methods, { type: 'EMAIL' });
        const phone = find(this.contact.methods, { type: 'SMS' });
        const contactInfo = {
            emailId: email ? email.value : '',
            phoneNumber: phone ? phone.value : '',
        };
        return actions.getOrderContactInfo(contactInfo);
    };

    getOrderTotals = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        const orderTotals = {};
        /* istanbul ignore else */
        if (this.totals) {
            each(this.totals, (total) => {
                orderTotals[`${total.type}`] = total.amount;
                // eslint-disable-next-line no-unused-expressions
                if (total.type === ANALYTICS_SUB_TOTAL) {
                    LocalStorage.setData(ANALYTICS_LOCAL_STORAGE_KEY_CART_TOTAL, total.amount);
                }
            });
            /* istanbul ignore else  */
            if (!this.isPriceAccurate) {
                orderTotals['ORDER AMOUNT'] = 'TBD';
            }
        }
        if (this.orderDetails?.agencyInfo?.voucherCode && !TokenProvider.get('Voucher_Number')) {
            orderTotals.voucherNumber = this.orderDetails.agencyInfo.voucherCode;
        }
        return actions.getOrderTotals(orderTotals);
    };

    getBillingInfo = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        let billing = {};
        if (!this.billing) {
            billing = { creditCards: { cards: [] } };
        } else {
            billing = this.billing;
        }
        let billingInfo = {};
        /* istanbul ignore else */
        if (
            billing.creditCards &&
            billing.creditCards.cards &&
            billing.creditCards.cards.length > 0 &&
            billing.creditCards.cards[0].address
        ) {
            billingInfo = billing.creditCards.cards[0].address;
        } else if (billing.paypal && billing.paypal.address) {
            billingInfo = billing.paypal.address;
        } else if (billing.unnamed && billing.unnamed.giftCards && billing.unnamed.address) {
            billingInfo = billing.unnamed.address;
        }
        return actions.getOrderBillingInfo(billingInfo);
    };

    getShippingGroupInfo = () => {
        if (isEmpty(this.orderDetails) || isEmpty(this.delivery) || isEmpty(this.delivery.groups)) {
            return this.defaultAction;
        }

        const shippingGroups = this.delivery && this.delivery.groups;
        const { items } = this.bag;
        // Aurora API not return groups on delivery GET order service call.
        /* istanbul ignore else */
        if (shippingGroups) {
            each(shippingGroups, (shippingGroup) => {
                const group = shippingGroup;
                let bagItems = [];
                const bopisPickUpDate = [];
                each(items, (item) => {
                    const itemLevelDeliveryGroup = find(item.deliveryOptions, { selected: true });
                    /* istanbul ignore if */
                    if (itemLevelDeliveryGroup.code === group.type) {
                        const bagItem = item;
                        bagItem.href = group.href;
                        bagItems = [...bagItems, item];
                    }
                    // MCYODA-29001: If order is placed after cutoff time then pick up should display as tomorrow. This is derived from pickupDateMessage from draft order api at itme level
                    if (itemLevelDeliveryGroup.code === 'BOPIS') {
                        const message = itemLevelDeliveryGroup?.pickupDateMessage?.includes(
                            'Tomorrow'
                        )
                            ? 'Tomorrow'
                            : 'Today';
                        bopisPickUpDate.push(message);
                    }
                });
                // MCYODA-29001: There are some edge case when we have multiple BOPIS item in same order. For some items pickupDateMessage says tomorrow and for some items its Today. In that case it should be displayed as today.
                if (!isEmpty(bopisPickUpDate)) {
                    const index = indexOf(bopisPickUpDate, 'Today');
                    if (index !== -1) {
                        group.pickupDateMessage = 'Today';
                    } else {
                        group.pickupDateMessage = 'Tomorrow';
                    }
                }
                group.bagItems = bagItems;
            });
        }
        // Rearrange to show BOPIS shipping group as first
        /* istanbul ignore if */
        if (shippingGroups && shippingGroups.length > 1) {
            const bopisGroupIndex = findIndex(shippingGroups, { type: 'BOPIS' });
            // If index is 0 then BOPIS is already present as the first element
            if (bopisGroupIndex > 0) {
                const bopisGroup = shippingGroups.splice(bopisGroupIndex, 1);
                shippingGroups.unshift(bopisGroup[0]);
            }
        }
        return actions.getOrderShippingGroupsInfo(shippingGroups);
    };

    getShippingMethodsList = () => {
        if (isEmpty(this.orderDetails) || isEmpty(this.delivery)) {
            return this.defaultAction;
        }
        let shippingMethods = {};
        const homeShippingGroup = find(this.delivery.groups, (group) => group.type === 'HOME');
        homeShippingGroup && (shippingMethods = homeShippingGroup.serviceLevels);
        return actions.setOrderShippingMethods(shippingMethods);
    };

    getOrderItems = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        return actions.getOrderItems(this.bag.items);
    };

    getGiftWrapInfo = () => {
        if (isEmpty(this.orderDetails) || isEmpty(this.giftWraps)) {
            return this.defaultAction;
        }

        const { giftWraps } = this;
        const { items } = this.bag;
        /* istanbul ignore else  */
        if (giftWraps && giftWraps.length > 0) {
            each(giftWraps, (giftWrap) => {
                const gift = giftWrap;
                let giftWrapItems = [];
                each(giftWrap.items, (item) => {
                    const giftItem = find(items, { id: item.id });
                    giftItem.href = item.href;
                    giftItem.quantity = item.quantity;
                    giftWrapItems = [...giftWrapItems, giftItem];
                });
                gift.items = giftWrapItems;
            });
        }
        return actions.getOrderGiftWrapInfo(giftWraps);
    };

    getOrderAdjustments = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }

        const adjustmentInfo = [];
        let rewardsCount = 0;
        let rewardsAmount = 0;
        let rewardsPresent = false;
        let rewardAdjustment = {};
        let rewardId;
        let rewardsMessage;
        /* istanbul ignore else  */
        if (this.adjustments) {
            // Please do not disturb the sequence. It is used for front end display purpose.
            // Sequence 1: Rewards
            each(this.adjustments, (adjustment) => {
                if (adjustment.code === ADJUSTMENT_TYPE_REWARD) {
                    rewardsPresent = true;
                    rewardsCount += 1;
                    rewardsAmount += adjustment.amount;
                    rewardId = adjustment.id;
                    rewardsMessage = adjustment.message;
                }
            });
            /* istanbul ignore else  */
            if (rewardsPresent) {
                rewardAdjustment = {
                    amount: rewardsAmount,
                    code: ADJUSTMENT_TYPE_REWARD,
                    value: 'Reward',
                    count: rewardsCount,
                    message: rewardsMessage,
                };
                if (rewardsCount === 1) {
                    rewardAdjustment.id = rewardId;
                }
                adjustmentInfo.push(rewardAdjustment);
            }

            // Sequence 2: Coupons
            each(this.adjustments, (adjustment) => {
                if (
                    adjustment.code !== ADJUSTMENT_TYPE_REWARD &&
                    adjustment.code !== ADJUSTMENT_TYPE_ASSOC_DISCOUNT
                ) {
                    adjustmentInfo.push(adjustment);
                }
            });

            // Sequence 3: Associate Discount
            const assocAdjustment = find(this.adjustments, {
                code: ADJUSTMENT_TYPE_ASSOC_DISCOUNT,
            });
            /* istanbul ignore else */
            if (assocAdjustment) {
                assocAdjustment.value = 'Assoc. Discount';
                adjustmentInfo.push(assocAdjustment);
            }

            // Sequence 4: Shipping Discount
            /* istanbul ignore next */
            const shippingAdjustment = find(
                this.adjustments,
                (shippingAdjustments) =>
                    shippingAdjustments.code === ADJUSTMENT_TYPE_SHIPPING &&
                    shippingAdjustments.subType === ADJUSTMENT_TYPE_SHIPPING
            );
            if (shippingAdjustment) {
                shippingAdjustment.code = ADJUSTMENT_TYPE_COUPON;
                shippingAdjustment.description = ADJUSTMENT_TYPE_FREE_SHIP;
                adjustmentInfo.push(shippingAdjustment);
            }
        }
        return actions.getOrderAdjustments(adjustmentInfo);
    };

    getAppliedRewards = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }

        const appliedRewardsArray = [];
        /* istanbul ignore else  */
        if (this.adjustments) {
            each(this.adjustments, (adjustment) => {
                if (adjustment.code === ADJUSTMENT_TYPE_REWARD) {
                    const rewardObject = {
                        id: adjustment.id,
                        issueDate: null,
                        expiryDate: null,
                        expiresIn: null,
                        dollarOff: adjustment.amountType === DOLLAROFF,
                        percentOff: adjustment.amountType === PERCENTOFF,
                        certValue:
                            adjustment.amountType === PERCENTOFF
                                ? adjustment.percentageOff
                                : adjustment.amount,
                        type: adjustment.value,
                        code: adjustment.value,
                        serialNumber: adjustment.serialNumber,
                        manualEntry: true,
                        applied: true,
                    };
                    appliedRewardsArray.push(rewardObject);
                }
            });
        }
        return actions.getOrderRewards(appliedRewardsArray);
    };

    getOrderCharges = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        const orderCharges = [];
        const cartItems = this.bag.items;
        const hasTruckableItem =
            find(cartItems, (item) => item.product.truckable === true) !== undefined;
        /* istanbul ignore else */
        if (this.charges) {
            const deliveryChargeItem = find(this.charges, {
                type: CHARGE_TYPE_SHIPPING_AND_HANDLING,
            });
            const estimatedTax = find(this.charges, { name: 'estimated tax' });
            const estimatedSts = find(this.charges, { name: 'estimated ship to store' });

            if (deliveryChargeItem && deliveryChargeItem.name === 'estimated shipping & handling') {
                if (!hasTruckableItem) {
                    deliveryChargeItem.name = 'Est. Standard Delivery';
                }
                if (hasTruckableItem) {
                    deliveryChargeItem.amount =
                        deliveryChargeItem.amount === 0 ? 'INCLUDED' : deliveryChargeItem.amount;
                    deliveryChargeItem.name = 'Est. Shipping & Handling';
                }
            }
            if (estimatedTax) {
                estimatedTax.name = 'tax';
                estimatedTax.type = 'TAX';
                estimatedTax.amount = 'TBD';
            }
            if (estimatedSts) {
                estimatedSts.name = 'Or Ship to Store';
            }

            /* istanbul ignore else  */
            if (this.delivery.groups && this.delivery.groups.length > 0) {
                const deliverToStore = find(this.delivery.groups, {
                    type: SHIPPING_GROUP_TYPE_STORE,
                });
                if (deliverToStore && deliveryChargeItem) {
                    deliveryChargeItem.name = 'Ship To Store';
                }

                const deliveryGroup = find(this.delivery.groups, {
                    type: SHIPPING_GROUP_TYPE_HOME,
                });
                // deliveryGroup && LocalStorage.setData('GRShippingGroupId', deliveryGroup.id, true);
                /* istanbul ignore else */
                if (deliveryGroup && !isEmpty(deliveryGroup.address)) {
                    /* istanbul ignore next  */
                    if (
                        deliveryGroup.serviceLevels &&
                        deliveryGroup.serviceLevels.data &&
                        deliveryGroup.serviceLevels.data.length > 0
                    ) {
                        const deliveryType = find(deliveryGroup.serviceLevels.data, {
                            selected: true,
                        });
                        if (
                            deliveryChargeItem &&
                            deliveryType &&
                            ((hasTruckableItem && deliveryType.code === 'TRUCK') ||
                                (!hasTruckableItem && deliveryType.code !== 'TRUCK'))
                        ) {
                            deliveryChargeItem.name = `${
                                shippingDeliveryType[deliveryType.code]
                            } Delivery`;
                        }
                    } else if (deliveryChargeItem) {
                        deliveryChargeItem.name = 'Standard Delivery';
                    }
                }

                let shippingCouponAdj = false;
                /* istanbul ignore else  */
                if (this.adjustments) {
                    shippingCouponAdj = find(this.adjustments, {
                        description: ADJUSTMENT_TYPE_FREE_SHIP,
                    });
                    /* istanbul ignore else  */
                    if (shippingCouponAdj) {
                        deliveryChargeItem.value = shippingCouponAdj.value;
                        deliveryChargeItem.isCouponNotApplied = shippingCouponAdj.amount === 0;
                    }
                }
            }

            const { charges } = this;

            each(charges, (charge) => {
                const updateCharge = charge;
                if (!this.isPriceAccurate) {
                    updateCharge.amount = 'TBD';
                }
                orderCharges.push(updateCharge);
            });

            // Move tax to the end of charges
            const indexOfTax = findIndex(orderCharges, { type: 'TAX' });
            if (indexOfTax > -1) {
                orderCharges.push(orderCharges.splice(indexOfTax, 1)[0]);
            }

            // Move round up to the end of charges
            const indexOfCharge = findIndex(orderCharges, { type: 'ROUND UP' });
            /* istanbul ignore else  */
            if (indexOfCharge > -1) {
                orderCharges.push(orderCharges.splice(indexOfCharge, 1)[0]);
            }
        }
        return actions.getOrderCharges(orderCharges);
    };

    getOrderPaymentInfo = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        const paymentInfo = [];

        /* istanbul ignore else */
        if (this.billing) {
            const { billing } = this;
            const isApplePayEnabled = this.orderDetails.applePayEligible;
            /* istanbul ignore else */
            if (
                billing.unnamed &&
                billing.unnamed.giftCards &&
                billing.unnamed.giftCards.length > 0
            ) {
                each(billing.unnamed.giftCards, (giftCard) => {
                    const cardItem = {};
                    cardItem.id = giftCard.id;
                    cardItem.paymentMethod = 'giftCard';
                    cardItem.type = 'GIFTCARD';
                    cardItem.lastFour = `**${giftCard.number}`;
                    cardItem.amount = giftCard.amount;
                    cardItem.balance = giftCard.balance;
                    cardItem.currency = this.currency;
                    paymentInfo.push(cardItem);
                });
            }
            /* istanbul ignore else */
            if (
                billing.creditCards &&
                billing.creditCards.cards &&
                billing.creditCards.cards.length > 0
            ) {
                const cardItem = {};
                each(billing.creditCards.cards, (creditCard) => {
                    cardItem.id = creditCard.id;
                    cardItem.amount = creditCard.amount;
                    cardItem.currency = this.currency;
                    cardItem.status = creditCard.status;
                    cardItem.paymentMethod = 'creditCard';
                    cardItem.applePay = false;
                    if (creditCard.subtype === BNPL_SYF) {
                        cardItem.firstName = creditCard.address.firstName;
                        cardItem.lastName = creditCard.address.lastName;
                        cardItem.type = creditCard.subtype;
                    } else {
                        cardItem.type = creditCard.type;
                        cardItem.lastFour = `**${this.getCCLastFourDigit(
                            creditCard.type,
                            creditCard.lastFour
                        )}`;
                        cardItem.relationshipId =
                            creditCard.relationships &&
                            creditCard.relationships.accountPaymentMethod &&
                            creditCard.relationships.accountPaymentMethod.id;
                    }
                    if (
                        creditCard.tags &&
                        creditCard.tags.length > 0 &&
                        creditCard.tags[0] === 'ApplePay' &&
                        isApplePayEnabled
                    ) {
                        cardItem.applePay = true;
                        if (creditCard.subtype === BNPL_SYF) {
                            cardItem.lastFour = `**${this.getCCLastFourDigit(
                                creditCard.type,
                                creditCard.lastFour
                            )}`;
                        }
                    }
                });
                let options = get(billing, 'creditCards.financing.options');
                if (!options) {
                    options = get(billing, 'creditCards.cards[0].financing.options');
                }
                /* istanbul ignore else */
                if (options) {
                    cardItem.financingOptions = options;
                }
                !isEmpty(cardItem) && paymentInfo.push(cardItem);
            }
            /* istanbul ignore else */
            if (billing.paypal && billing.paypal.amount > 0) {
                const cardItem = {};
                cardItem.paymentMethod = 'paypal';
                cardItem.type = 'PAYPAL';
                cardItem.lastFour = billing.paypal.email;
                cardItem.amount = billing.paypal.amount;
                cardItem.firstName = billing.paypal.address.firstName;
                cardItem.lastName = billing.paypal.address.lastName;
                cardItem.currency = this.currency;
                cardItem.token = billing.paypal.token;
                cardItem.status = billing.paypal.status;

                paymentInfo.push(cardItem);
            }
        }

        return actions.getOrderPaymentInfo(paymentInfo);
    };

    getCertonaAttributes = (context) => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        const attrMap = {
            ids: [],
            qties: [],
            prices: [],
        };
        const enableSinglePPIDRecommendation = get(
            context,
            'featureFlags.enableSinglePPIDRecommendation',
            true
        );
        /* istanbul ignore else  */
        if (this.bag.items && this.bag.items.length > 0) {
            if (enableSinglePPIDRecommendation) {
                attrMap.ids.push(this.bag.items[0].product.id);
            } else {
                each(this.bag.items, (item) => {
                    attrMap.ids.push(item.product.id);
                    attrMap.qties.push(item.quantity);
                    const itemTotal = find(item.totals, {
                        name: ITEMS_TOTALS_NAME_TOTAL_WITHOUT_DISCOUNT,
                    });
                    attrMap.prices.push(itemTotal.amount);
                });
            }
        }
        const customerId = User.getUserId();
        let certonaAttributes = {};
        // Aurora API not return "totals" if comem as null.
        if (this.totals) {
            const subTotal = find(this.totals, { name: ORDER_TOTAL_NAME_SUBTOTAL });
            let itemid;
            let qty;
            let price;
            if (enableSinglePPIDRecommendation) {
                itemid = this.bag.items[0].product.id;
                qty = this.bag.items[0].quantity;
                price = this.bag.items[0].prices[0].amount;
            } else {
                itemid = join(attrMap.ids, ';');
                qty = join(attrMap.qties, ';');
                price = join(attrMap.prices, ';');
            }
            certonaAttributes = {
                customerid: customerId,
                recommendations: true,
                itemid,
                qty,
                price,
                total: subTotal.amount,
                transactionid: this.number,
            };
        }
        return actions.getCertonaAttributes(certonaAttributes);
    };

    getOrderGiftRegistries = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }

        // initialize the object to be returned.
        const orderGiftRegistries = {
            itemsPresent: false,
            registries: [],
            items: [],
            shippingGroupId: null,
        };
        /* istanbul ignore else  */
        if (this.delivery && this.delivery.groups && this.delivery.groups.length > 0) {
            const deliveryGroup = find(this.delivery.groups, { type: SHIPPING_GROUP_TYPE_HOME });
            deliveryGroup && (orderGiftRegistries.shippingGroupId = deliveryGroup.id);
        }

        // iterate through the bag items and update the gift registry item status.
        /* istanbul ignore else  */
        if (this.bag && !isEmpty(this.bag.items)) {
            each(this.bag.items, (item) => {
                const arrayItem = {};
                arrayItem.itemId = item.id;
                arrayItem.manualGift = true; // assuming the item is a regular non gift registry item.

                if (!isEmpty(item.giftRegistry)) {
                    arrayItem.regId = item.giftRegistry.id;
                    arrayItem.regName = item.giftRegistry.name;
                    arrayItem.regType = item.giftRegistry.type;
                    arrayItem.manualGift = false; // we know that the item was added from a gift registry.

                    const registryItem = {};
                    registryItem.id = item.giftRegistry.id;
                    registryItem.name = item.giftRegistry.name;
                    registryItem.type = item.giftRegistry.type;

                    orderGiftRegistries.registries.push(registryItem);
                    orderGiftRegistries.itemsPresent = true;
                    // LocalStorage.setData('GiftRegistryId', item.giftRegistry.id, true);
                }
                orderGiftRegistries.items.push(arrayItem);
            });
        }

        if (orderGiftRegistries.itemsPresent) {
            orderGiftRegistries.registries = uniqWith(orderGiftRegistries.registries, isEqual);
        }

        orderGiftRegistries.registries &&
            orderGiftRegistries.registries.length !== 1 &&
            (orderGiftRegistries.itemsPresent = false);

        // LocalStorage.setData('isGRItemPresent', orderGiftRegistries.itemsPresent, true);

        return getOrderGiftRegistries(orderGiftRegistries);
    };

    getItemDeliverySummary = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        const { items } = this.bag;
        const shipToHome = {};
        const shipToStore = {};
        const sameDayPickup = {};
        const deliverySummary = {};
        const regex = /<.*>\s+/gm;

        let deliveryDate = '';
        let storeId = '';
        let count = 0;
        items.map((item) => {
            const selectedShipping = find(item.deliveryOptions, { selected: true });
            const { quantity } = item;
            /* istanbul ignore next */
            if (
                selectedShipping.code === SHIPPING_GROUP_TYPE_HOME &&
                selectedShipping.deliveryPromiseMessage
            ) {
                deliveryDate = selectedShipping.deliveryPromiseMessage;
                deliveryDate = deliveryDate.replace(regex, '');
                count = shipToHome[deliveryDate] ? shipToHome[deliveryDate] + quantity : quantity;
                shipToHome[deliveryDate] = count;
            } else if (
                selectedShipping.code === SHIPPING_GROUP_TYPE_STORE &&
                selectedShipping.deliveryPromiseMessage
            ) {
                deliveryDate = selectedShipping.deliveryPromiseMessage;
                deliveryDate = deliveryDate.replace(regex, '');
                count = shipToStore[deliveryDate] ? shipToStore[deliveryDate] + quantity : quantity;
                shipToStore[deliveryDate] = count;
            } else if (selectedShipping.code === SHIPPING_GROUP_TYPE_BOPIS) {
                storeId = selectedShipping.storeId;
                count = sameDayPickup[storeId] ? sameDayPickup[storeId] + quantity : quantity;
                sameDayPickup[storeId] = count;
            }
            return null;
        });

        deliverySummary.shipToHome = shipToHome;
        deliverySummary.shipToStore = shipToStore;
        deliverySummary.sameDayPickup = sameDayPickup;

        return actions.getItemDeliverySummary(deliverySummary);
    };

    getCheckoutAccordionSections = (actioName) => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        let index = 0;
        function getIndex() {
            index += 1;
            return index;
        }
        const accordionSectionsInfo = {
            SDPU: { isExists: false },
            shipping: { isExists: false },
            payment: { isExists: true },
        };
        const shippingGroups = this.delivery && this.delivery.groups;
        const bopusShippingGroup = shippingGroups && find(shippingGroups, { type: 'BOPIS' });
        if (
            bopusShippingGroup &&
            bopusShippingGroup.bagItems &&
            bopusShippingGroup.bagItems.length > 0
        ) {
            accordionSectionsInfo.SDPU = {
                isExists: true,
                index: getIndex(),
                type: 'BOPIS',
            };
        }
        /* istanbul ignore else  */
        if (
            shippingGroups &&
            (find(shippingGroups, { type: 'HOME' }) || find(shippingGroups, { type: 'STORE' }))
        ) {
            accordionSectionsInfo.shipping = {
                isExists: true,
                index: getIndex(),
                type: find(shippingGroups, { type: 'HOME' }) ? 'HOME' : 'STORE',
            };
        }
        accordionSectionsInfo.payment.index = getIndex();
        if (actioName) {
            const actionMap = {};
            actionMap[CHECKOUT_ACCORDION_TITLE_SDPU] = 'SDPU';
            actionMap[CHECKOUT_ACCORDION_TITLE_SHIPPING] = 'shipping';
            actionMap[CHECKOUT_ACCORDION_TITLE_SHIPPING.toLowerCase()] = 'shipping';
            actionMap[CHECKOUT_ACCORDION_TITLE_PAYMENT] = 'payment';
            actionMap[CHECKOUT_ACCORDION_TITLE_PAYMENT.toLowerCase()] = 'payment';
            const selectedAccordionKey = actionMap[actioName];
            accordionSectionsInfo.selectedAccordionIndex =
                accordionSectionsInfo[selectedAccordionKey].index;
        }
        return checkoutActions.getCheckoutSectionsInfo(accordionSectionsInfo);
    };

    validateShippingAddress = () => {
        if (isEmpty(this.orderDetails) || isEmpty(this.delivery)) {
            return this.defaultAction;
        }

        const shippingGroups = this.delivery && this.delivery.groups;
        if (shippingGroups && find(shippingGroups, { type: 'HOME', address: null })) {
            return shippingActions.setServiceLevelsRequested(true);
        }

        return this.defaultAction;
    };

    checkInternationalShippingError = () => {
        if (!isEmpty(this.orderDetails)) {
            const shippingException = find(this.status.exceptions, {
                errorCode: 'API_ERR_FIELD_HOME_INTL_COUNTRY_NOT_SUPPORTED',
            });
            if (shippingException) {
                return shippingActions.handleInternationalShippError(shippingException);
            }
        }
        return this.defaultAction;
    };

    checkErrors = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }

        const oosException = ExceptionHandler.handleOOSException(this.status.exceptions);
        if (oosException) {
            const creditCardInfo = this.billing?.creditCards?.cards[0];
            const isBnplOnOrder = creditCardInfo?.subtype === 'BNPL_SYF';
            const oosInfo = getDataForOOS(this.bag.items, isBnplOnOrder);
            return setOosDetails({ ...oosInfo });
        }
        return ExceptionHandler.handlePaymentExeption(this.status.exceptions, this.defaultAction);
    };

    getCCLastFourDigit = (ccType, lastFour) => {
        if (!ccType || !lastFour) {
            return lastFour;
        }
        let lastFourDigit = lastFour;
        const lastDigit = lastFourDigit.slice(lastFourDigit.length - 1);
        if (ccType === 'JCP' && lastDigit !== '*') {
            lastFourDigit = `${lastFourDigit}*`;
        }
        return lastFourDigit;
    };

    getAlternateCharges = () => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        const charges = [];
        if (!isEmpty(this.altCharges)) {
            const homeCharge = find(this.altCharges, { type: 'SHIP TO HOME' });
            homeCharge && (homeCharge.name = 'Est. Standard Delivery');
            homeCharge && charges.push(homeCharge);
            const storeCharge = find(this.altCharges, { type: 'SHIP TO STORE' });
            storeCharge && charges.push(storeCharge);
            const taxCharge = find(this.altCharges, { type: 'TAX' });
            taxCharge.amount = taxCharge.amount === 0 ? 'TBD' : taxCharge.amount;
            taxCharge && charges.push(taxCharge);
            const amtCharge = find(this.altCharges, { type: 'ORDER AMOUNT' });
            amtCharge && charges.push(amtCharge);
            const overSizeItem = find(this.altCharges, { type: 'OVERSIZE SURCHARGE' });
            overSizeItem && charges.push(overSizeItem);
        }
        return setAltCharges(charges);
    };

    getExpressCheckoutInfo = (showExpressCheckoutCheckBox) => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        if (!showExpressCheckoutCheckBox) {
            return expressCheckoutDisplayed(false);
        }
        const {
            delivery: { groups },
        } = this.orderDetails;
        let showExpressCheckout = false;
        let paymentExpressCheckout;
        let addressExpressCheckout;
        const shipToHome = find(groups, { type: 'HOME' });
        if (shipToHome) {
            paymentExpressCheckout = get(
                this.orderDetails,
                'billing.creditCards.cards[0].expressCheckout'
            );
            addressExpressCheckout = find(groups, {
                type: 'HOME',
                address: { expressCheckout: false },
            });
            showExpressCheckout =
                (addressExpressCheckout || paymentExpressCheckout === false) && true;
        }
        return expressCheckoutDisplayed(
            showExpressCheckout,
            addressExpressCheckout,
            paymentExpressCheckout
        );
    };

    /**
     * Init new checkout page reducer
     * @return {*}
     */
    initNewCheckoutSections = (
        reduxEffectPut,
        renderFrom,
        isLoadedFromReview,
        ignoreDAReadyEvent,
        isDeleteFromOOS
    ) => {
        if (isEmpty(this.orderDetails)) {
            return this.defaultAction;
        }
        const checkoutSectionsInfo = {
            SDPU: { isExists: false, index: '1' },
            shipping: { isExists: true, index: '1' },
            payment: { isExists: true, index: '2' },
            review: { isExists: true, index: '3' },
            isLoadedFromReview,
            activePage: renderFrom,
        };
        const shippingGroups = this.delivery && this.delivery.groups;
        const bopisShippingGroup = find(shippingGroups, { type: 'BOPIS' });
        const shippingGroup =
            find(shippingGroups, { type: 'HOME' }) || find(shippingGroups, { type: 'STORE' });
        if (bopisShippingGroup) {
            checkoutSectionsInfo.SDPU.isExists = true;
            if (shippingGroup) {
                checkoutSectionsInfo.shipping.index = 2;
                checkoutSectionsInfo.payment.index = 3;
                checkoutSectionsInfo.review.index = 4;
            } else {
                checkoutSectionsInfo.shipping.isExists = false;
            }
        }
        const initCheckoutActions = [];
        let initPageRenderActions = {};
        /**
         * Set checkout accordion section info
         */
        initCheckoutActions.push(
            reduxEffectPut(checkoutActions.initNewCheckoutSections(checkoutSectionsInfo))
        );
        let pageName = ANALYTICS_PAGE_NAME_CHECKOUT_PAYMENT;
        if (renderFrom === 'bopis') {
            /**
             * Init shipping BOPIS section
             */
            initPageRenderActions = initBOPISSection;
            pageName = ANALYTICS_PAGE_NAME_CHECKOUT_SAME_DAY_PICKUP;
        } else if (renderFrom === 'shipping' || isDeleteFromOOS) {
            /**
             * Init shipping shipping section
             */
            initPageRenderActions = initNewShippingSection;
            pageName = ANALYTICS_PAGE_NAME_CHECKOUT_SHIPPING;
        } else {
            /**
             * Init shipping payment section
             */
            initPageRenderActions = handleInitPaymentRequestSaga;
        }
        /* istanbul ignore else */
        if (!__SERVER__ && !ignoreDAReadyEvent) {
            /**
             * Fire Page load DA event if serer side failed.
             */
            initCheckoutActions.push(
                reduxEffectPut(checkoutAnalyticsActions.pageLoadSuccessAnalyticsAction(pageName))
            );
        }
        return {
            initCheckoutActions,
            initPageRenderActions,
        };
    };

    updateNewCheckoutSection = (reduxEffectPut, checkoutInfo) => {
        const updateNewCheckoutActions = [];
        if (checkoutInfo.activePage === 'shipping') {
            updateNewCheckoutActions.push(
                reduxEffectPut(updateShippingMethodList(this.orderDetailsAPIResponse))
            );
        } else if (checkoutInfo.activePage === 'payment') {
            updateNewCheckoutActions.push(reduxEffectPut(initNewPayment(true)));
        }
        return updateNewCheckoutActions;
    };
}
